(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("VueDemi"), require("FEGOBridge"), require("FEGORender"));
	else if(typeof define === 'function' && define.amd)
		define(["VueDemi", "FEGOBridge", "FEGORender"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/vertical-anchor-tab/render"] = factory(require("VueDemi"), require("FEGOBridge"), require("FEGORender"));
	else
		root["/fego/component/vertical-anchor-tab/render"] = factory(root["VueDemi"], root["FEGOBridge"], root["FEGORender"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__9906__, __WEBPACK_EXTERNAL_MODULE__7145__, __WEBPACK_EXTERNAL_MODULE__2477__) => {
return 